import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RoadmapProgressStatus } from '@edtech-ui/constants/student-roadmap-ta.enum';

import { ApiBaseResponse } from '@edtech-ui/core/models/api-base-model';
import {
  GenerateRoadmap,
  GenerateRoadmapResponse,
  MyRoadmapResponse,
  PublicRoadmapResponse,
  RoadmapDetailsResponse,
  RoadmapProgressResponse,
  RoadmapAndProgressResponse,
  TopicDetailsResponse,
} from '@edtech-ui/core/models/roadmap/roadmap';


import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RoadmapServiceService {

  apiUrl = environment.roadMapApiUrl;

  constructor(private http: HttpClient) { }


  generateRoadmap(payload: GenerateRoadmap) {
    return this.http.post<GenerateRoadmapResponse>(
      `${this.apiUrl}/generate`,
      payload
    );
  }

  getMyroadmaps(page: number = 1, limit: number = 20): Observable<MyRoadmapResponse> {
    return this.http.get<MyRoadmapResponse>(`${this.apiUrl}`, {
      params: { page: page.toString(), limit: limit.toString() }
    });
  }


  getPublicRoadmap(page: number = 0, limit: number = 20): Observable<PublicRoadmapResponse> {
    return this.http.get<PublicRoadmapResponse>(`${this.apiUrl}/public/browse`, {
      params: { page: page.toString(), limit: limit.toString() }
    });
  }

  getRoadmapDetails(id: string): Observable<RoadmapDetailsResponse> {
    return this.http.get<RoadmapDetailsResponse>(`${this.apiUrl}/${id}`)
  }


  startRoadmapProgress(roadmapId: string) {
    return this.http.post<ApiBaseResponse>(
      `${this.apiUrl}/${roadmapId}/progress/start`,
      {}
    );
  }

  getRoadmapWithProgress(
    roadmapId: string
  ): Observable<RoadmapProgressResponse> {
    return this.http.get<RoadmapProgressResponse>(
      `${this.apiUrl}/${roadmapId}/progress`
    );
  }

  getRoadmapAndProgress(
    roadmapId: string
  ): Observable<RoadmapAndProgressResponse> {
    return this.http.get<RoadmapAndProgressResponse>(
      `${this.apiUrl}/${roadmapId}/with-progress`
    );
  }

  updateSubtopicProgress(
    roadmapId: string,
    topicId: string,
    subtopicId: string,
    status: RoadmapProgressStatus
  ) {
    return this.http.patch<RoadmapProgressResponse>(
      `${this.apiUrl}/${roadmapId}/topics/${topicId}/subtopics/${subtopicId}/progress`,
      { status }
    );
  }
  updateTopicProgress(
    roadmapId: string,
    topicId: string,
    body: { status: RoadmapProgressStatus }
  ) {
    return this.http.patch<RoadmapProgressResponse>(
      `${this.apiUrl}/${roadmapId}/topics/${topicId}/progress`,
      body
    );
  }

  getTopicDetails(
    roadmapId: string,
    topicId: string
  ): Observable<TopicDetailsResponse> {
    return this.http.get<TopicDetailsResponse>(
      `${this.apiUrl}/${roadmapId}/topics/${topicId}`
    );
  }

  forkRoadmap(roadmapId: string) {
    return this.http.post<RoadmapDetailsResponse>(
      `${this.apiUrl}/${roadmapId}/fork`,
      {}
    );
  }
}
